var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 1.24967C10 1.47884 9.8125 1.66634 9.58333 1.66634H0.416667C0.1875 1.66634 0 1.47884 0 1.24967C0 1.02051 0.1875 0.833008 0.416667 0.833008H9.58333C9.8125 0.833008 10 1.02051 10 1.24967ZM6.25 8.33301H3.75C3.52083 8.33301 3.33333 8.52051 3.33333 8.74967C3.33333 8.97884 3.52083 9.16634 3.75 9.16634H6.25C6.47917 9.16634 6.66667 8.97884 6.66667 8.74967C6.66667 8.52051 6.47917 8.33301 6.25 8.33301ZM7.91667 4.58301H2.08333C1.85417 4.58301 1.66667 4.77051 1.66667 4.99967C1.66667 5.22884 1.85417 5.41634 2.08333 5.41634H7.91667C8.14583 5.41634 8.33333 5.22884 8.33333 4.99967C8.33333 4.77051 8.14583 4.58301 7.91667 4.58301Z",
    fill: "#0A1435"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/sort.1560d0e154ba2bf987430d44504144e8.svg";
export { ForwardRef as ReactComponent };